import { errorReport } from '@/utils/index.js'
import urlHelper from '@lib/utils/urlHelper'
import { mpUtils } from '@tujia/fe-lib-bridge'
import { channelTypes } from '@common-libs/tj-channel'
import { wrapAuthorizeUrl } from '@common-libs/tj-channel/elong'
import { getMpLinkWithCode } from '@/utils/linkUtil'
import { outcodeHandler } from '@/utils/outcodeHandler'

export default {
  methods: {
    getParams(query) {
      const channelId = this.$route.query.code || `cms_${this.$root.promotionId}`
      const args = {}
      const url = query.split('?')
      const params = url[1].split('&')
      for (let i = 0; i < params.length; i++) {
        const keyValue = params[i].split('=')
        const key = keyValue[0]
        args[key] = keyValue[1]
      }
      const cUrlCode = window.atob(args.url)
      if (cUrlCode.search('&channelId=') !== -1) {
        return query
      } else {
        const cUrlBase = window.btoa(cUrlCode + `&channelId=${channelId}`)
        let cUrl = url[0] + '?'
        for (let key in args) {
          if (key == 'url') {
            cUrl += `&url=${cUrlBase}`
          } else {
            cUrl += `&${key}=${args[key]}`
          }
        }
        return cUrl
      }
    },
    /**
     * URL跳转-区分不同平台
     * @param {Object} props 跳转的url对象，包含mpLink，appLink，activeLink
     * @param {Boolean} isOpenAppUrl 唤起app时是否打开props内的appUrl
     */
    async doRedirect(props, isOpenAppUrl) {
      // mpLink
      // /pages/units/units?destId=17&destName=西安
      const { code = `cms_${this.$root.promotionId}` } = this.$route.query
      try {
        const { isWxMpEnv, isTujiaAppEnv, isCtripAppEnv, isAlipayClient } = this.platformEnv
        if (isWxMpEnv && props.activeLink) {
          const h5url = props.activeLink + `${props.activeLink.indexOf('?') > -1 ? '&' : '?'}code=${code}&tjchannelid=${this.tjChannelId}`
          // let wxUrl = this.tjChannelId === channelTypes.ELONG ? `/page/home/webview/webview?src=${encodeURIComponent(wrapAuthorizeUrl(h5url))}` : `/pages/tbnb/pages/common/webview/index?h5url=${encodeURIComponent(h5url)}`
          const wxUrl = this.tjChannelId === channelTypes.ELONG ? `/page/home/webview/webview?src=${encodeURIComponent(wrapAuthorizeUrl(h5url))}` : getMpLinkWithCode(props.mpLink, h5url, code)
          mpUtils.navigateTo({
            url: wxUrl
          })
        } else if (isCtripAppEnv && (props.cAppLink || props.appLink)) {
          // 红包过来的参数，没有cAppLink, 只有appLink
          const cUrl = props.cAppLink || props.appLink
          // 如果是https链接，说明“图片-文章类型”，处理h5链接
          const isReg = /^(http|https)/
          const h5Url = isReg.test(cUrl)
          const jumpUrl = h5Url ? cUrl : this.getParams(cUrl)
          if (h5Url) {
            this.openScheme(jumpUrl)
            return
          }
          window.location.href = jumpUrl
        } else if (isTujiaAppEnv && props.appLink) {
          // 如果是https链接，说明“图片-文章类型”，处理h5链接
          const isReg = /^(http|https)/
          const h5Url = isReg.test(props.appLink)
          if (h5Url) {
            this.openScheme(props.appLink)
            return
          }
          const channelId = props.appLink.search('&channelId=')
          const outcode = outcodeHandler(this.$route.query)
          const urlOutCode = outcode ? `&outcode=${outcode}` : ''
          window.location.href = channelId !== -1 ? props.appLink : (props.appLink + `&channelId=${code}${urlOutCode}`)
        } else if (isAlipayClient && props.activeLink) {
          // 支付宝浏览器
          if (isOpenAppUrl) {
            const appId = 2018101061620818
            let query = link.split('?')[1]
            const mpPage = encodeURIComponent('/pages/units/units')
            // eslint-disable-next-line no-undef
            window.location.href = `alipays://platformapi/startapp?appId=${appId}&page=${mpPage}&query=${encodeURIComponent(query)}`
          } else {
            this.jumpAliClientAndMP(props.activeLink, props.isJumpApp)
          }
        } else if (props.activeLink) {
          if (this.$root.isMobile) {
            if (props.isJumpApp) {
              if (isOpenAppUrl && props.appLink) {
                // 跳转房屋列表页
                let _id = urlHelper.getQueryStringByStringUrl(props.appLink).id
                let _cds = decodeURIComponent(props.appLink).split('cds=')[1]
                window.location.href = `tujia://com.tujia.hotel/list?id=${_id}&cityId=${_id}&cds=${_cds}`
              } else {
                window.location.href = `tujia://com.tujia.hotel/web?url=${encodeURIComponent(props.activeLink)}`
              }
              this.autoLinkApp(props.activeLink)
            } else {
              window.location.href = props.activeLink
            }
          } else {
            window.location.href = props.activeLink
          }
        }
      } catch (e) {
        errorReport(e)
      }
    },
    autoLinkApp(src) {
      // TUDO: isJumpApp 需要添加
      let timer = setTimeout(() => {
        window.location.href = src
        clearTimeout(timer)
      }, 500)
    },
    /**
     *
     * 支付宝webview下跳转逻辑
     */
    jumpAliClientAndMP(src, isJump) {
      this.getAliEnv().then((res) => {
        if (res) {
          // mp
          window.location.href = src
        } else {
          if (isJump) {
            const appId = 2018101061620818
            const mpPage = encodeURIComponent('/pages/webview/index')
            // beginDate=2019-06-08&endDate=2019-06-09&unitId=241557&peopleCount=1
            const mpQuery = `h5url=${src}`
            // eslint-disable-next-line no-undef
            window.location.href = `alipays://platformapi/startapp?appId=${appId}&page=${mpPage}&query=${encodeURIComponent(mpQuery)}`
          } else {
            window.location.href = src
          }
        }
      })
    },
    getAliEnv() {
      return new Promise((resolve, reject) => {
        // eslint-disable-next-line no-undef
        my.getEnv((res) => {
          if (res && res.miniprogram) {
            resolve(true)
          } else {
            resolve(false)
          }
        })
      })
    },
    openScheme(url) {
      let scheme = url
      const { isTujiaAppEnv, isCtripAppEnv, isQunarAppEnv } = this.platformEnv
      if (/^(http|https)/.test(url) && url.indexOf('app.tujia.com') === -1) {
        if (isCtripAppEnv && window.CtripUtil && window.CtripUtil?.app_open_url) {
          window.CtripUtil.app_open_url(url, 2, '', '', true)
          return
        }
        if (isQunarAppEnv && window.hysdk && window.hysdk?.openWebView) {
          window.hysdk.openWebView({ url })
          return
        }
        if (isTujiaAppEnv) {
          // 没有navbar=0转场效果会有问题 前端兜底处理
          if (url.indexOf('navbar=0') === -1) {
            scheme = url + (url.indexOf('?') > -1 ? '&' : '?') + 'navbar=0'
          }
          scheme = `tujia://tujia.com/web?url=${encodeURIComponent(scheme)}`
        }
      }
      window.location.href = scheme
    }
  }
}
